<div class="page-not-found">
  <h1 class="heading text-center mt-4">You Seem Lost!</h1>
  <hr>
  <div class="d-flex justify-content-center">
    <img class="d-block mw-100"src="assets/product/404Icon.svg">
  </div>
  <div class="body-copy text-center mt-4">Sorry about that! Use the links in the header to get around or go back <a class="cta" href="/"><span>Home</span></a></div>
</div>
